import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import AdminGeneralDefinitionsToolbar from './AdminGeneralDefinitionsToolbar';
import AdminGeneralDefinitionsForm from './AdminGeneralDefinitionsForm';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6'
  }
});


class AdminGeneralDefinitionsTable extends React.Component {


  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.paperRoot}>
        <AdminGeneralDefinitionsToolbar titleTableList={this.props.titleTableList} />
        <AdminGeneralDefinitionsForm />
      </Paper>
    );
  }
}

AdminGeneralDefinitionsTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default AdminGeneralDefinitionsTable = withStyles(styles)(AdminGeneralDefinitionsTable);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminGeneralDefinitions/AdminGeneralDefinitionsTable.js